const materialOrderPopulate = {
    order_requests: {
        populate: {
            shipment: true,
            receipt_position: { populate: { receipt: true } },
        },
    },
}

export const materialRequirementsPopulate = {
    material_type: true,
    configurations: {
        populate: {
            material: {
                populate: {
                    ...materialOrderPopulate,
                    stocks: {
                        populate: {
                            stock_reserves: { populate: { shipment: true } },
                        },
                    },
                },
            },
        },
    },
}

export const shipmentAvailabilityPopulate = {
    stamp: { populate: ['tube', 'roller', 'last_order'] },
    virtualStamp: { populate: ['roller'] },
    form_set: {
        populate: {
            forms: { populate: { form_order: true } },
        },
    },
    additional_jobs: true,
    blankPreviewFiles: true,
}

/** Менеджер (автор отгрузки), дизайнер и куратор — для колонок «Доп.» и «К» в плане печати и на станках */
export const shipmentPeoplePopulate = {
    user_audit: {
        populate: {
            created_by_permissions_user: {
                fields: ['documentId', 'username'],
            },
        },
    },
    designer: {
        fields: ['documentId', 'username'],
    },
    // Для колонки «К»: куратор по задаче согласования
    tasks: {
        filters: { type: { $eq: 'Согласование задания' } },
        fields: ['type', 'taskStatus', 'endDate', 'createdAt'],
        populate: {
            performer: { fields: ['documentId', 'username'] },
        },
    },
}
